<template>
    <div class="contextmenu" v-show="menuShow" :style="{ top: menuTop + 'px', left: menuLeft + 'px' }" v-if="copyData.length>0||curFeatures.length>0">
        <ul @mouseup="handleMouseUp">
            <template v-if="copyData.length>0">
                <li class="menu-item" @click="unSelectedComponent"><i class="el-icon-close"></i>取消</li>
                <li class="menu-item" @click="pasteComponent">
                    <i class="iconfont icon-niantie"></i>粘贴
                </li>
            </template>
            <template v-else>
                <li class="menu-item" @click="unSelectedComponent"><i class="el-icon-close"></i>取消</li>
                <li class="menu-item" v-if="curFeatures.length>0&&menuhasFeature" @click="deleteComponent"><i class="el-icon-delete"></i>删除</li>
                <li class="menu-item" v-if="curFeatures.length>0&&menuhasFeature"  @click="copyCompontent">
                    <i class="el-icon-document-copy"></i>复制
                </li>
                <li class="menu-item" v-if="curFeatures.length>0&&menuhasFeature"  @click="cutCompontent">
                    <i class="el-icon-document-copy"></i>剪切
                </li>
                <li class="menu-item" v-if="curFeatures.length==1&&menuhasFeature" 
                    @click="rotateCompontent('counterclockwise')"><i class="el-icon-refresh-left"></i>旋转</li>
                <li class="menu-item" v-if="curFeatures.length==1&&menuhasFeature" 
                    @click="rotateCompontent('clockwise')"><i class="el-icon-refresh-right"></i>旋转</li>
            </template>
        </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import _filter from "lodash/filter";
import {Select} from 'ol/interaction';
import {LineString} from 'ol/geom';

import {calculateCenter,renderFeature,renderCutFeature} from '../../utils/mapUtils';

import {Fill, Text,Stroke,Style,Icon} from 'ol/style';
import { deepCopy } from '../../utils/utils';
import Feature from 'ol/Feature';

import { generateID as generateFID } from '../../utils/utils';


export default {
    data() {
        return {
            baseUrl: this.$store.state.assetsUrl, // 静态资源路径
            menuTop:0, // 右键菜单显示位置
            menuLeft:0, // 右键菜单显示位置
        }
    },
    computed:{
        ...mapState('simulation',[
            'menuhasFeature',
            'menuCoor',
            'menuShow',
            'menuStart', // 菜单上一次点击到位置
            'mouseCoor', // 当前鼠标位置
            'curFeatures', // 当前选中的对象数组
            'drawSource', // 当前绘图图层
            'map', // 当前地图

            'nodes', // 当前节点的索引
            'lines', // 当前管道数组

            'copyData', // 拷贝数据
            'isCut', // 是否是剪切
        ]),
        // 当前选中的Feature
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        },
    },
    watch:{
        menuCoor(newValue){
            if(newValue){
                let px=this.map.getPixelFromCoordinate(newValue);
                this.menuLeft=px[0]||0;
                this.menuTop=px[1]||0;
            }
        }
    },
    mounted(){
        this.$bus.$on("cut",this.cutCompontent); // 剪切
        this.$bus.$on("copy",this.copyCompontent); // 复制
        this.$bus.$on("paste",this.pasteComponent); // 粘贴
        this.$bus.$on("delected",this.deleteComponent); // 删除
        this.$bus.$on("rotate",this.rotateCompontent); // 删除
    },
    methods: {
       
        // 点击菜单时不取消当前组件的选中状态
        handleMouseUp() {
            this.$store.commit('simulation/setClickComponentStatus', true)
        },
        // 取消选中
        unSelectedComponent(){
            let interactions=this.map.getInteractions();
            interactions.forEach(item=>{
                if(item instanceof Select){
                    let selectArr=item.getFeatures();
                    selectArr.clear();
                }
            });

            // 取消选中
            this.$store.commit("simulation/setCurFeatures",[]);
            // 取消粘贴
            this.$store.commit("simulation/copy",[]);
            // 取消剪切
            this.$store.commit("simulation/cut",[]);
            // 取消右键显示
            this.$store.commit("simulation/hideContextMenu");

        },
        // 删除组件
        deleteComponent(){
            let curFeatures=this.curFeatures;
            // 先过滤一遍,判断数组里面有没有选中的对象
            let has=false;
            for(let j=0;j<curFeatures.length;j++){
                let feature=curFeatures[j];
                if(feature==this.curFeature){
                    has=true;
                }
            }
            if(!has&&this.curFeature){
                curFeatures.push(this.curFeature);
            }
            // 执行删除任务
            for(let i=0;i<curFeatures.length;i++){
                let feature=curFeatures[i];
                // 删除相应的引用数组
                let _type=feature.get("_type");
                if(_type!="line"){ // 删除的Feature不是线段
                    let tempNodes=[]; // 节点列表
                    let tempType="common";
                    switch(_type){
                        case "input":
                            tempNodes=this.nodes["input"];
                            tempType="input";
                            break;
                        case "unknownInput":
                            tempNodes=this.nodes["unknownInput"];
                            tempType="unknownInput";
                            break;
                        case "unknowOutput":
                        case "output":
                            tempNodes=this.nodes["output"];
                            tempType="output";
                            break;
                        default:
                            tempNodes=this.nodes["common"];
                            tempType="common";
                            break;
                    }

                    tempNodes=_filter(tempNodes,item=>{
                        let id=item.get("id");
                        return id!=feature.get("id");
                    });
                    this.nodes[tempType]=tempNodes;
                    this.$store.commit("simulation/setNodes",this.nodes);
                
                }else{
                    let lines=this.lines;
                    lines=_filter(lines,item=>{
                        let id=item.get("id");
                        return id!=feature.get("id");
                    });
                    this.$store.commit("simulation/setLines",lines);
                }
                
                // 删除地图上的内容
                let source=this.drawSource;
                source.removeFeature(feature);
                
                // 删除当前选中内容
                curFeatures.splice(i,1);
                i--;
            }

            // 取消选中
            this.$store.commit("simulation/setCurFeatures",[]);
            // 记录快照
            this.$store.commit("simulation/recordSnapshot");
        },
        // 旋转组件
        rotateCompontent(direction){
            direction=direction||"counterclockwise";
            let feature=this.curFeature;
            if(feature){
                let geom=feature.getGeometry();
                const type = geom.getType();
                if(type !="Point"){ // 如果旋转的不是一个点
                    let center=calculateCenter(geom);

                    let rotation=0;
                    if(direction=="counterclockwise"){
                        rotation-=90*Math.PI/180;
                    }else{
                        rotation+=90*Math.PI/180;
                    }
                    geom.rotate(rotation,center.center);


                    // 如果此时线段上有设备点，则应想办法同步移动设备点
                    // 因为记录了设备点的比率信息，所以可以通过设备位于线段的比率进行重新计算
                    let devices=feature.get("devices");
                    if(devices){
                        for(let item of devices){
                            let devices_geom=item.getGeometry();
                            let nodeProps=item.getProperties();
                            let ration=nodeProps.ration;
                            if(ration){
                                let first_point=geom.getFirstCoordinate();
                                let last_point=geom.getLastCoordinate();
                                let x=ration[0]*(last_point[0]-first_point[0])+first_point[0];
                                let y=ration[1]*(last_point[1]-first_point[1])+first_point[1];
                                devices_geom.setCoordinates([x,y]);
                            }
                        }
                    }

                }else{
                    // 获取图片
                    let nodeProps=feature.getProperties();
                    // 旋转角度
                    let rotation=nodeProps.rotation;
                    if(!rotation){
                        rotation=0;
                    }
                    if(direction=="counterclockwise"){
                        rotation-=90*Math.PI/180;
                    }else{
                        rotation+=90*Math.PI/180;
                    }
   
                    let nodeId=nodeProps.id;
                    let text="("+nodeId+")";
                    let iconStyle = [
                        new Style({
                            image: new Icon({
                                src: this.baseUrl+'/img/simulation/red.png',
                                scale:0.9,
                            }),
                            stroke: new Stroke({
                                color: 'red',
                                width: 2,
                            }),
                            zIndex:1
                        }),
                        new Style({
                            image: new Icon({
                                src: this.baseUrl+'/img/simulation/'+nodeProps.img+'?_v'+this.version,
                                scale:0.7,
                                rotation:rotation,
                            }),
                            stroke: new Stroke({
                                color: 'red',
                                width: 2,
                            }),
                            text:new Text({
                                font:'15px "Fira Sans", sans-serif',
                                text:text,
                                offsetY:-35,
                                fill:new Fill({
                                    color:"red"
                                })
                            }),
                            zIndex:1000
                        }),
                    ];
                    // 保存旋转角度
                    feature.set("rotation",rotation);

                    // 保存样式
                    feature.setStyle(iconStyle);
                }

            }

            // 记录快照
            this.$store.commit("simulation/recordSnapshot");
        },

        // 复制组件
        copyCompontent(){
            // 获取当前选中组件
            let copyArray=[];
            for(let curFeature of this.curFeatures){
                copyArray.push(curFeature);
            }
            // 保存待复制数据
            this.$store.commit("simulation/copy",copyArray);
            // 取消右键显示
            this.$store.commit("simulation/hideContextMenu"); 
        },
        // 剪切
        cutCompontent(){
            let cutArray=[];
            // 获取当前选中组件
            for(let curFeature of this.curFeatures){
                // 保存剪切的数据
                cutArray.push(curFeature);
                // 设置剪切的样式，主要就是浅色的标记
                renderCutFeature(curFeature);
            }
            // 保存待复制数据
            this.$store.commit("simulation/cut",cutArray);
            // 取消右键显示
            this.$store.commit("simulation/hideContextMenu"); 
        },

        // 粘贴组件
        pasteComponent(){
            if(!this.copyData) return;

            // 粘帖全部的数据
            let copyArray=this.copyData;
            let deltaX = Number.MIN_VALUE;
            let deltaY = Number.MIN_VALUE;
            let drawSource=this.drawSource;
            for(let copyData of copyArray){
                let geom=copyData.getGeometry();
                if(deltaX==Number.MIN_VALUE&&deltaY==Number.MIN_VALUE){
                    // 图形开始位置
                    let start=[0,0];
                    /**
                     * 如果存在上一次菜单坐标
                     */
                    if(this.menuStart){
                        start=this.menuStart;
                    }else{
                        if(geom instanceof LineString){
                            start=geom.getFirstCoordinate();
                        }else{
                            start=geom.getCoordinates();
                        }
                    }

                    // 坐标结束位置
                    let end=this.mouseCoor||start; // 结束坐标

                    // 计算偏移量
                    deltaX = end[0]-start[0];
                    deltaY = end[1]-start[1];
                }

                /**
                 * 创建并生成要素对象
                 */
                let tempCopyData=new Feature(); // 为了避免不必要的麻烦，重新创建一个新的要素     
                let tempFeature=copyData; // 克隆
                let tempGeom=tempFeature.getGeometry();
                tempGeom=tempGeom.clone();
                // 执行移动
                tempGeom.translate(deltaX, deltaY);
                tempCopyData.setGeometry(tempGeom);
                // 需要忽略的属性
                let ignores=['geometry','lines','first_point','last_point',"devices"];  
                let nodeProps=copyData.getProperties();
                let tempP=deepCopy(nodeProps,ignores); // 对属性数据进行深度拷贝
                tempCopyData.setProperties(tempP);
                // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
                let fid=(new Date()).getTime();
                tempCopyData.setId(fid);

                // 执行后续操作
                if(this.isCut){
                    // 删除原始图形
                    drawSource.removeFeature(copyData);
                    // 将新创建的要素添加到地图上
                    drawSource.addFeature(tempCopyData);
                }else{
                    // 生成新的id号
                    let tempId=this.generateID(nodeProps);
                    // console.log(tempId);
                    if(tempId<0){ // 如果编号非法，则不允许复制
                        tempCopyData=null;
                        return;
                    }
                    tempCopyData.set("id",tempId);
                    let fid=generateFID();
                    tempCopyData.setId(fid);
                    // 将新创建的要素添加到地图上
                    drawSource.addFeature(tempCopyData);

                    // 修改相关store数组
                    let _node_type=nodeProps._type;
                    if(_node_type=='line'){
                        this.lines.push(tempCopyData); // 增加管道索引
                    }else{
                        let _node_type=nodeProps._type;
                        let node_tepm_name="common";
                        switch(_node_type){
                            case "input":
                                node_tepm_name="input";
                                break;
                            case "unknownInput":
                                node_tepm_name="unknownInput";
                                break;
                            case "unknowOutput":
                            case "output":
                                node_tepm_name="output";
                                break;
                            default:
                                break;
                        }
                        let nodes=this.nodes[node_tepm_name];
                        if(!nodes){
                            nodes=[];
                            this.nodes[node_tepm_name]=[];
                        }
                        // 节点数组增加
                        this.nodes[node_tepm_name].push(tempCopyData);
                    }
                }

                // 重设要素样式
                renderFeature(copyData);

            }
            // 通知其他的组件管道加载完成了,这里暂时可能有问题，待以后再处理
            this.$store.commit("simulation/setLines",this.lines);
            // 提交节点保存
            this.$store.commit("simulation/setNodes",this.nodes);
            // 取消选中
            this.unSelectedComponent();
            // 记录快照
            this.$store.commit("simulation/recordSnapshot");
        },

        // 生成唯一id
        generateID(nodeProps){
            // 创建一个Feature
            let _node_type=nodeProps._type;
            let nodeId=0;
            if(_node_type=="line"){ // 管道节点
                // 设置id号
                nodeId=this.lines.length;
                // 遍历全部管线，查找最大id号
                this.lines.forEach(item=>{
                    let tempid=item.get("id");
                    tempid=parseInt(tempid);
                    if(nodeId<=tempid){
                        nodeId=tempid+1;
                    }
                });
            }else{
                let node_tepm_name="common";
                switch(_node_type){
                    case "input":
                        node_tepm_name="input";
                        break;
                    case "unknownInput":
                        node_tepm_name="unknownInput";
                        break;
                    case "unknowOutput":
                    case "output":
                        node_tepm_name="output";
                        break;
                    default:
                        break;
                }
                let nodes=this.nodes[node_tepm_name];
                if(!nodes){
                    nodes=[];
                    this.nodes[node_tepm_name]=[];
                }

                // 输入节点以及待求输入节点在绘图时只允许出现一次
                if(nodeProps._type=="unknownInput"||nodeProps._type=="input"){
                    if(nodes.length>0){
                        return -1;
                    }
                }
                // input、output、unknownInput和unknownOutput编号从100开始
                nodeId=nodes.length+1;
                if(nodeProps._type=="unknownInput"||nodeProps._type=="input"||nodeProps._type=="unknowOutput"||nodeProps._type=="output"){
                    // 遍历几个数组，找编号最大值
                    let tempid=0;
                    // 待求输入节点
                    if(this.nodes['unknownInput']){
                        this.nodes['unknownInput'].forEach(item=>{
                            let tid=item.get("id");
                            tid=parseInt(tid);
                            if(tempid<=tid){
                                tempid=tid+1;
                            }
                        });
                    }
                    // 输入节点
                    if(this.nodes['input']){
                        this.nodes['input'].forEach(item=>{
                            let tid=item.get("id");
                            tid=parseInt(tid);
                            if(tempid<=tid){
                                tempid=tid+1;
                            }
                        });
                    }
                    // 输出节点
                    if(this.nodes['output']){
                        this.nodes['output'].forEach(item=>{
                            let tid=item.get("id");
                            tid=parseInt(tid);
                            if(tempid<=tid){
                                tempid=tid+1;
                            }
                        });
                    }
                    // 要从100开始编号
                    if(tempid<=100){
                        tempid+=100;
                    }
                    nodeId=tempid;
                }else{
                    // 遍历通用
                    let tempid=0;
                    if(this.nodes['common']){
                        this.nodes['common'].forEach(item=>{
                            let tid=item.get("id");
                            tid=parseInt(tid);
                            if(tempid<=tid){
                                tempid=tid+1;
                            }
                        });
                    }
                    nodeId=tempid;
                }
            }

            return nodeId;
            
        }
    },
}
</script>

<style lang="scss" scoped>
.contextmenu {
    position: absolute;
    z-index: 1000;

    ul {
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-sizing: border-box;
        margin: 5px 0;
        padding: 6px 0;

        li {
            font-size: 14px;
            padding: 0 20px;
            position: relative;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #606266;
            height: 34px;
            line-height: 34px;
            box-sizing: border-box;
            cursor: pointer;

            &:hover {
                background-color: #f5f7fa;
            }

            i{
                margin-right: 5px;
            }
        }

        .disabled{
            color: #aaa;
        }
    }
}
</style>